import React, { Dispatch, SetStateAction, useState } from "react";

import { RegulatorySearchFilterType } from "@/components/business/RegulatoryContainer/regulatoryList.types";
import SearchInput from "@atoms/SearchInput/SearchInput";
import { useRegulatoryListFilterState } from "@stores/regulatoryList";

import {
  REGULATORY_LIST_EDITOR_INFO_FILTER,
  REGULATORY_LIST_EDITOR_INFO_FILTER_KEY,
} from "./constants/editorInfoFilter.constants";
import * as S from "./RegulatoryEditorInfoSearch.style";
import CtgListSearchFilterSelect from "../RegulatoryPressInfoSearch/components/RegulatorySearchFilterSelect/RegulatorySearchFilterSelect";

interface Props {
  currentEditorFilter: RegulatorySearchFilterType;
  setCurrentFilter: Dispatch<SetStateAction<RegulatorySearchFilterType>>;
}

const RegulatoryEditorInfoSearch = ({
  currentEditorFilter,
  setCurrentFilter,
}: Props) => {
  const [regulatoryListFilter, setRegulatoryListFilter] =
    useRegulatoryListFilterState();
  const [typing, setTyping] = useState("");

  const { search } = regulatoryListFilter;

  const handleSearchKeyboard = () => {
    const currentInput = typing.trim();

    const newSearch = { ...search };
    REGULATORY_LIST_EDITOR_INFO_FILTER_KEY.forEach(
      (key) => delete newSearch[key],
    );
    newSearch[currentEditorFilter.key] = currentInput;

    if (currentInput) {
      setRegulatoryListFilter({
        ...regulatoryListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  const handleSearchButton = () => {
    const currentInput = typing || search?.[currentEditorFilter.key];

    const newSearch = { ...search };
    REGULATORY_LIST_EDITOR_INFO_FILTER_KEY.forEach(
      (key) => delete newSearch[key],
    );
    newSearch[currentEditorFilter.key] = currentInput;

    if (currentInput) {
      setRegulatoryListFilter({
        ...regulatoryListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  return (
    <S.EditorInfoSearchWrapper>
      <CtgListSearchFilterSelect
        subTitle="Editor Filter"
        filterList={REGULATORY_LIST_EDITOR_INFO_FILTER}
        currentFilter={currentEditorFilter}
        setCurrentFilter={setCurrentFilter}
        isEditor
      />
      <S.EditorInfoSearchTitle>
        <SearchInput
          placeholder="Search Editors"
          onSearchButton={handleSearchButton}
          handleSearchKeyboard={handleSearchKeyboard}
          typing={typing}
          setTyping={setTyping}
        />
      </S.EditorInfoSearchTitle>
    </S.EditorInfoSearchWrapper>
  );
};

export default RegulatoryEditorInfoSearch;
